import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { adminTransactionsReqSchema } from "~/entities/transaction";

import { AdminTransactions } from "./Transactions";

export function createAdminTransactionsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/transactions",
    component: AdminTransactions,
    validateSearch: adminTransactionsReqSchema,
    head: () => ({
      meta: [{ title: "Search Transactions" }],
    }),
  });
}
